class SizeGuide {
  constructor() {
    this.currentUnit = 'in';
    this.init();
  }

  init() {
    const sizeGuide = document.querySelector('.size-guide-drawer');
    if (!sizeGuide) return;

    const sizeGuideType = sizeGuide.dataset.sizeGuide;
    const data = window.SizeGuideData[sizeGuideType];

    if (!data) {
      console.warn(`Size guide data not found for type: ${sizeGuideType}`);
      return;
    }

    // Render external video if available (Shopify videos are rendered server-side)
    this.renderExternalVideo(sizeGuide);

    // Auto-play Shopify videos when drawer opens
    this.playShopifyVideo(sizeGuide);

    this.renderInstructions(data.instructions);
    this.renderTable(data.data);
    this.bindEvents();
  }

  playShopifyVideo(sizeGuide) {
    const video = sizeGuide.querySelector('video.size-guide-drawer__video');
    if (video) {
      // Try to play the video
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // Autoplay was prevented, user interaction required
          console.log('Video autoplay prevented:', error);
        });
      }
    }
  }

  renderExternalVideo(sizeGuide) {
    const videoUrl = sizeGuide.dataset.videoUrl;
    if (!videoUrl) return;

    const videoContainer = sizeGuide.querySelector('.size-guide-drawer__video-container');
    if (!videoContainer) return;

    // Check if it's a YouTube or Vimeo URL
    let embedUrl = '';
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      // Extract YouTube video ID
      let videoId = '';
      if (videoUrl.includes('youtu.be/')) {
        videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
      } else if (videoUrl.includes('youtube.com/watch?v=')) {
        videoId = videoUrl.split('v=')[1].split('&')[0];
      } else if (videoUrl.includes('youtube.com/embed/')) {
        videoId = videoUrl.split('embed/')[1].split('?')[0];
      }
      if (videoId) {
        embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`;
      }
    } else if (videoUrl.includes('vimeo.com')) {
      // Extract Vimeo video ID
      const videoId = videoUrl.split('vimeo.com/')[1].split('?')[0];
      if (videoId) {
        embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&loop=1`;
      }
    }

    if (embedUrl) {
      videoContainer.innerHTML = `
        <div class="size-guide-drawer__video-wrapper">
          <iframe
            class="size-guide-drawer__video"
            src="${embedUrl}"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            loading="lazy"
          ></iframe>
        </div>
      `;
    }
  }

  renderInstructions(instructions) {
    const container = document.querySelector(
      '.size-guide-drawer__instructions'
    );
    if (!container) return;

    container.innerHTML = instructions
      .map(
        (instruction) => `
      <div class="size-guide-drawer__instruction">
        <div class="size-guide-drawer__instruction-title">${instruction.title}</div>
        <div class="size-guide-drawer__instruction-description">${instruction.description}</div>
      </div>
    `
      )
      .join('');
  }

  renderTable(data) {
    const thead = document.querySelector('.size-guide-drawer__table-header');
    const tbody = document.querySelector('.size-guide-drawer__table-body');

    if (!thead || !tbody || !data.length) return;

    // Get all measurement types (excluding Size)
    const measurementTypes = Object.keys(data[0]).filter(
      (key) => key !== 'Size'
    );

    // Render header
    thead.innerHTML = `
      <tr>
        <th>Size</th>
        ${measurementTypes.map((type) => `<th>${type}</th>`).join('')}
      </tr>
    `;

    // Render body
    tbody.innerHTML = data
      .map((row) => {
        const sizeCell =
          typeof row.Size === 'object'
            ? `${row.Size[this.currentUnit]}`
            : row.Size;

        return `
        <tr>
          <td>${sizeCell}</td>
          ${measurementTypes
            .map((type) => {
              if (
                typeof row[type] === 'object' &&
                row[type][this.currentUnit]
              ) {
                return `<td>${row[type][this.currentUnit]}</td>`;
              } else if (typeof row[type] === 'string') {
                return `<td>${row[type]}</td>`;
              } else {
                return `<td>-</td>`;
              }
            })
            .join('')}
        </tr>
      `;
      })
      .join('');
  }

  bindEvents() {
    // Unit toggle
    document.querySelectorAll('.size-guide-drawer__unit').forEach((button) => {
      button.addEventListener('click', (e) => {
        document
          .querySelectorAll('.size-guide-drawer__unit')
          .forEach((btn) =>
            btn.classList.remove('size-guide-drawer__unit--active')
          );
        e.target.classList.add('size-guide-drawer__unit--active');
        this.currentUnit = e.target.dataset.unit;
        this.updateTable();
      });
    });
  }

  updateTable() {
    const sizeGuide = document.querySelector('.size-guide-drawer');
    if (!sizeGuide) return;

    const sizeGuideType = sizeGuide.dataset.sizeGuide;
    const data = window.SizeGuideData[sizeGuideType];

    if (!data) return;

    this.renderTable(data.data);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new SizeGuide();
});

// Initialize when drawer opens
document.addEventListener('click', (e) => {
  // Check if size guide drawer is being opened
  if (e.target.closest('[aria-controls="Size-Guide-menu-drawer"]')) {
    // Small delay to ensure drawer content is rendered
    setTimeout(() => {
      new SizeGuide();
    }, 100);
  }
});

// Also initialize if the size guide is loaded dynamically
document.addEventListener('size-guide-loaded', () => {
  new SizeGuide();
});
